const CategoryDetail = () => {
    return <h1>Category Detail Page</h1>;
};

export default CategoryDetail;